var _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternRecognition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 187,
    viewBox: "0 0 237 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 236.333,
    height: 187,
    rx: 16,
    fill: "#EFEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.333,
    y: 24,
    width: 188.333,
    height: 139,
    rx: 16.3778,
    fill: "#DED6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8567 127.205C61.8183 125.167 58.333 126.611 58.333 129.493V147.3C58.333 150.448 60.885 153 64.033 153H81.8397C84.7223 153 86.166 149.515 84.1276 147.476C83.5208 146.87 82.6978 146.529 81.8397 146.529H70.5044C67.3564 146.529 64.8044 143.977 64.8044 140.829V129.493C64.8044 128.635 64.4635 127.812 63.8567 127.205ZM84.1275 38.5237C83.5207 39.1305 82.6977 39.4714 81.8396 39.4714H70.5044C67.3564 39.4714 64.8044 42.0234 64.8044 45.1714V56.5065C64.8044 57.3647 64.4635 58.1877 63.8567 58.7945C61.8183 60.8329 58.333 59.3893 58.333 56.5065V38.7C58.333 35.552 60.885 33 64.033 33H81.8396C84.7223 33 86.1659 36.4853 84.1275 38.5237ZM172.809 58.9456C172.203 58.3388 171.862 57.5158 171.862 56.6577V45.1714C171.862 42.0234 169.31 39.4714 166.162 39.4714H154.675C153.817 39.4714 152.994 39.1305 152.387 38.5237C150.349 36.4853 151.793 33 154.675 33H172.633C175.781 33 178.333 35.552 178.333 38.7V56.6577C178.333 59.5403 174.848 60.984 172.809 58.9456ZM152.387 147.476C152.994 146.87 153.817 146.529 154.675 146.529H166.162C169.31 146.529 171.862 143.977 171.862 140.829V129.342C171.862 128.484 172.203 127.661 172.809 127.054C174.848 125.016 178.333 126.46 178.333 129.342V147.3C178.333 150.448 175.781 153 172.633 153H154.675C151.793 153 150.349 149.515 152.387 147.476Z",
    fill: "#B6A0FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118.333,
    cy: 93,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.171,
    cy: 93,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.333,
    cy: 63.3931,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7261,
    cy: 63.3931,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7261,
    cy: 93,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6822 122.607C98.6822 128.106 94.2246 132.563 88.7259 132.563C83.2271 132.563 78.7695 128.106 78.7695 122.607C78.7695 117.108 83.2271 112.651 88.7259 112.651C94.2246 112.651 98.6822 117.108 98.6822 122.607ZM81.2586 122.607C81.2586 126.731 84.6018 130.074 88.7259 130.074C92.8499 130.074 96.1931 126.731 96.1931 122.607C96.1931 118.483 92.8499 115.14 88.7259 115.14C84.6018 115.14 81.2586 118.483 81.2586 122.607Z",
    fill: "#A78EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.896 63.3931C157.896 68.8918 153.438 73.3494 147.94 73.3494C142.441 73.3494 137.983 68.8918 137.983 63.3931C137.983 57.8944 142.441 53.4368 147.94 53.4368C153.438 53.4368 157.896 57.8944 157.896 63.3931ZM140.472 63.3931C140.472 67.5171 143.816 70.8603 147.94 70.8603C152.064 70.8603 155.407 67.5171 155.407 63.3931C155.407 59.2691 152.064 55.9259 147.94 55.9259C143.816 55.9259 140.472 59.2691 140.472 63.3931Z",
    fill: "#A78EFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1582,
    y: 62.083,
    width: 11.2664,
    height: 3.1441,
    fill: "#A78EFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 127.766,
    y: 121.035,
    width: 11.2664,
    height: 3.1441,
    fill: "#A78EFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 116.761,
    y: 102.17,
    width: 3.1441,
    height: 12.0524,
    fill: "#A78EFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 116.761,
    y: 72.8254,
    width: 3.1441,
    height: 12.0524,
    fill: "#A78EFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.1543,
    y: 72.8254,
    width: 3.1441,
    height: 12.0524,
    fill: "#A78EFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146.368,
    y: 102.17,
    width: 3.1441,
    height: 12.0524,
    fill: "#A78EFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7259,
    cy: 63.3931,
    r: 9.95633,
    fill: "#623BE5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7259,
    cy: 93,
    r: 9.95633,
    fill: "#623BE5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.333,
    cy: 63.3931,
    r: 9.95633,
    fill: "#623BE5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.333,
    cy: 122.607,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.94,
    cy: 122.607,
    r: 12.8384,
    fill: "#6D42FF",
    fillOpacity: 0.15
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.333,
    cy: 93,
    r: 9.95633,
    fill: "#623BE5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.172,
    cy: 93,
    r: 9.95633,
    fill: "#623BE5"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.333,
    cy: 122.607,
    r: 9.95633,
    fill: "#623BE5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.94,
    cy: 122.607,
    r: 9.95633,
    fill: "#623BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRecognition);
export default __webpack_public_path__ + "static/media/pattern-recognition.a7591a0f1ea321a2d5f5bf5535da1891.svg";
export { ForwardRef as ReactComponent };